import { WebInstitutos } from './WebInstitutos.model';
import { WebModulos } from './WebModulos.model';
import { Plano } from "./plano.model";

export class ViewModelFiltroWebModulosTextos {
    idSeq: number;
    idPlano: number;
    idInstitutos: number;
    idModulos: number;
    nmTexto: string;
}